var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFechar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fechar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 2.1875C8.96875 2.1875 2.1875 8.96875 2.1875 17.5C2.1875 26.0312 8.96875 32.8125 17.5 32.8125C26.0312 32.8125 32.8125 26.0312 32.8125 17.5C32.8125 8.96875 26.0312 2.1875 17.5 2.1875ZM17.5 30.625C10.2812 30.625 4.375 24.7188 4.375 17.5C4.375 10.2812 10.2812 4.375 17.5 4.375C24.7188 4.375 30.625 10.2812 30.625 17.5C30.625 24.7188 24.7188 30.625 17.5 30.625Z",
    fill: "#9BA5B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.4062 25.1562L17.5 19.25L11.5938 25.1562L9.84375 23.4062L15.75 17.5L9.84375 11.5938L11.5938 9.84375L17.5 15.75L23.4062 9.84375L25.1562 11.5938L19.25 17.5L25.1562 23.4062L23.4062 25.1562Z",
    fill: "#9BA5B7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFechar);
export default __webpack_public_path__ + "static/media/fechar.fdf14d075cdb1b0daf19b7a0109937d9.svg";
export { ForwardRef as ReactComponent };